module.exports = __webpack_public_path__ + "static/media/incomerDetail.18e38a0e.svg";